module.exports = __webpack_public_path__ + "img/account-icon-active.f01e8664.svg";